import React from 'react';
import FilterTable from './FilterTable';
import Downloader from './Downloader';

export default class  MainApplicationContainer  extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            finished: false,
            stepIndex: 0,
            messages: []
        }

        this.handleNext  = this.handleNext.bind(this);
        this.handleSaveConnectionRules = this.handleSaveConnectionRules.bind(this);
        this.handlePrev  = this.handlePrev.bind(this);
        this.handleOpen  = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    handleNext(params = {}) {

        let steps = {
            stepIndex: this.state.stepIndex + 1,
            finished: this.state.stepIndex >= 3,
        };
        

        this.setState({...steps});
    }

    handleOpen() {
        this.setState({open: true});
    }

    handleClose() {
        this.setState({open: false});
    }


    handleSaveConnectionRules(params = {}) {
        this.handleNext(params);
    };

    handlePrev() {
        const {stepIndex} = this.state;
        if (stepIndex > 0) {
            this.setState({stepIndex: stepIndex - 1});
        }
    };
    
    render(){
        const {finished, stepIndex} = this.state;
        const contentStyle = {margin: '16px'};

        return (<div>
            <Stepper activeStep={stepIndex}>
                <Step>
                    <StepLabel>Set connection rules</StepLabel>
                </Step>
                <Step>
                    <StepLabel>Match the fields</StepLabel>
                </Step>
                <Step>
                    <StepLabel>Set products filtering</StepLabel>
                </Step>
                <Step>
                    <StepLabel>Get CSV file</StepLabel>
                </Step>
            </Stepper>
            <div style={contentStyle}>
                {finished ? (
                    <p>
                        <a
                            href="#"
                            onClick={(event) => {
                                event.preventDefault();
                                this.setState({stepIndex: 0, finished: false});
                            }}
                        >
                            Click here
                        </a> to reset the example.
                    </p>
                ) : (
                    <div>{this.getStepContent(stepIndex)}</div>
                )}
                <br/>
                <br/>
                <br/>
            </div>

            <Snackbar
                bodyStyle={{ height: 100, width: 500, flexGrow: 0 }}
                autoHideDuration={5000}
                open={this.state.messages.length > 0}
                message={this.state.messages.join('\n')}
            />
        </div>);

    }
}



// WEBPACK FOOTER //
// ./assets/src/js/MainApplicationContainer.jsx